import React from 'react';

import ImageStackLogo from 'src/images/image-stack.png';

const ShareSlideOverAdditionalLinksInfo = () => {
  return (
    <>
      <p className='text-bedrock-p-small'>
        A Journey can have multiple links - each link can be customized and personalized for the recipient you share
        this Journey with
      </p>
      <img src={ImageStackLogo} alt='journey-stacks' className='w-1/2' />
    </>
  );
};

export default ShareSlideOverAdditionalLinksInfo;
